
(function () {
    'use strict';

    angular
        .module('controlModule')
        .directive('grcControlReview', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);
        directiveScope.readOnly = '=?';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller', '$state', '$mdToast', 'grcControlService', 'commonAricService', function ($rootScope, $scope, $controller, $state, $mdToast, grcControlService, commonAricService) {

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/control/grcControlReview.[Template].tpl.html';
                $controller('BoxTmplController', { $scope: $scope });

                if (_.isObject($scope.boxContext) && _.isObject($scope.boxContext.view)) {
                    $scope.view = $scope.boxContext.view;
                } else {
                    $scope.view = {};
                }

                // Page is dirty
                $scope.pageIsDirty = function () {
                    $scope.view.needSaveChanges = true;
                    $rootScope.$broadcast('page-is-dirty');
                }
                $scope.pageIsNotDirty = function () {
                    $scope.view.needSaveChanges = false;
                    $rootScope.$broadcast('page-is-not-dirty');
                }

                // Update Control To Assess
                $scope.updateControlToAssess = function (updatedControlToAssess) {
                    _.assign($scope.boxModel, updatedControlToAssess.Assessment);
                };

                // Effectiveness Ratings
                $scope.effectivenessRatings = [{
                    computed: 'DesignEffectivenessComputedID',
                    final: 'DesignEffectivenessFinalID',
                    templateFullUrl: '/app/shared/grc/control/grcControlReview.full.DesignEffectiveness.tpl.html',
                    templateNavItemUrl: '/app/shared/grc/control/grcControlReview.nav.item.DesignEffectiveness.tpl.html',
                    editView: 'isEditingDesignEffectiveness'
                }, {
                    computed: 'ImplementationEffectivenessComputedID',
                    final: 'ImplementationEffectivenessFinalID',
                    templateFullUrl: '/app/shared/grc/control/grcControlReview.full.ImplementationEffectiveness.tpl.html',
                    templateNavItemUrl: '/app/shared/grc/control/grcControlReview.nav.item.ImplementationEffectiveness.tpl.html',
                    editView: 'isEditingImplementationEffectiveness'
                }, {
                    computed: 'OperationalEffectivenessComputedID',
                    final: 'OperationalEffectivenessFinalID',
                    templateFullUrl: 'clientapps/shared/grc/control/grcControlReview.full.OperationalEffectiveness.tpl.html',
                    templateNavItemUrl: '/app/shared/grc/control/grcControlReview.nav.item.OperationalEffectiveness.tpl.html',
                    editview: 'isEditingOperationalEffectiveness'
                }];

                $scope.overallRating = {
                    computed: 'OverallResultComputedID',
                    final: 'OverallResultFinalID',
                    comment: 'OverallOverrideComment',
                    actionsTemplateUrl: '/app/shared/grc/control/grcControlReview.full.ActionsFooter.tpl.html',
                    statusTemplateUrl: '/app/shared/grc/control/grcControlReview.full.StatusFooter.tpl.html',
                    editView: 'isEditingOverallResult'
                };

                // Show Change Action On Computed
                $scope.showChangeActionOnComputed = function (rating) {
                    if ($scope.readOnly) return false;
                    if (!$scope.boxModel) return;
                    if ($scope.boxModel.IsReviewed) return false;
                    if ($scope.showFinalRating(rating)) return false;
                    if ($scope.view.reviewInfos && !$scope.view.reviewInfos.CanReviewARICControl) return false;

                    return true;
                };

                // Show Final Rating
                $scope.showFinalRating = function (rating) {
                    if (!$scope.boxModel) return;

                    if ($scope.showEditRating(rating)) return true;

                    if (!$scope.boxModel[rating.final]) return false;

                    return $scope.boxModel[rating.final] !== $scope.boxModel[rating.computed];
                };

                $scope.showFullEffectivenessRatings = function () {
                    return _.some($scope.effectivenessRatings, function (rating) {
                        return $scope.showFinalRating(rating);
                    });
                };

                // Change Computed
                $scope.changeComputed = function (rating) {
                    if ($scope.readOnly) return;

                    $scope.boxModel[rating.final] = $scope.boxModel[rating.computed];
                    $scope.toggleEditRating(rating);
                    $scope.pageIsDirty();
                };

                // Change Final
                $scope.changeFinal = function (rating) {
                    if ($scope.readOnly) return;

                    $scope.toggleEditRating(rating);
                };

                // Toggle Edit Rating
                $scope.toggleEditRating = function (rating) {
                    if ($scope.readOnly) return;

                    $scope.view[rating.editView] = !$scope.view[rating.editView];
                };

                // Show Edit Rating
                $scope.showEditRating = function (rating) {
                    if (!$scope.boxModel || !$scope.boxModel) { return; }

                    return $scope.view[rating.editView];
                };

                // On Rating Change
                $scope.onRatingChange = function (rating) {
                    var worstEffectivenessRating = _.max($scope.effectivenessRatings, function (effRating) {

                        if (!$scope.boxModel[effRating.final]) {
                            return $scope.boxModel[effRating.computed];
                        }

                        return $scope.boxModel[effRating.final];
                    });

                    $scope.boxModel[$scope.overallRating.final] =
                        $scope.boxModel[worstEffectivenessRating.final] ||
                            $scope.boxModel[worstEffectivenessRating.computed];

                    if ($scope.showFinalRating($scope.overallRating)) {
                        $scope.view[$scope.overallRating.editView] = true;
                    }

                    $scope.pageIsDirty();
                };

            }],

            link: function (scope, elem, attrs) {

                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();
